<template>
    <div class="successfulDalog">
        <el-dialog  :visible.sync="successfulDalog" width="573px"  :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
					<div class="content">
							<div class="title">
									<div class="text">支付成功</div>
									<img class="tanx" src="./images/tanx.png" alt="" @click="closeDialog()">
							</div>
							<div class="main">
									<img class="success" src="../assets/success.png" alt="">
									<div class="name">支付成功！</div>
									<div class="info">您可在个人中心【{{objData.text}}】查看详情！</div>
                                    <div class="bianhao">订单编号:{{payOrder}}</div>
							</div>
                            
							<div class="btnBox">
					<div class="cxybz" @click="onUrl(objData.path)">查看订单</div>
                        <!-- <div class="cz" @click="onUrl(objData.path)">查看详情</div> -->
				</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "successfulDalog",
        props: {
            payOrder: {
                type: String,
                default: '',
            },
        },
        components: {
        },
        data() {
            return {
              successfulDalog: false,
							objData: {
								text: '',
								path: ''
							}
            }
        },
        computed: {
        },
        watch: {
            $route(to, from) {
            }
        },
        mounted() {
        },
        methods: {
					onUrl(url){
						this.$router.push({path: url})
					},
            closeDialog(orderType) {
							if (orderType == 'apply-cert') {
								this.objData.text = '我的存证'
								this.objData.path = '/myExisting'
							} else if (orderType == 'copyrightRegistration02') {
								this.objData.text = '我的登记'
								this.objData.path = '/MyDaftar'
							} else if (orderType == 'copyrightRegistration17') {
								this.objData.text = '我的预登记'
								this.objData.path = '/myDci'
							} else if (orderType == 'evidenceAndTort') {
								this.objData.text = '网页取证'
								this.objData.path = '/evidenceAndTort'
							}
              this.successfulDalog = !this.successfulDalog
            }
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.content{
    background: #fff;
    .title{
        display: flex;
        align-items: center;
        height: 66px;
        border-bottom: solid 1px #E5E5E5;
        padding: 0 26px;
        .text{
            font-size: 16px;
            font-weight: 700;
            color: #333;
        }
        .tanx{
            width: 14px;
            height: 14px;
            margin-left: auto;
            cursor: pointer;
        }
    }
    .main{
        font-size: 16px;
        text-align: center;
        padding: 64px 26px;
				.success{
					width: 150px;
					height: 150px;
					margin: auto;
				}
				.name{
					margin-top: 36px;
					text-align: center;
					font-size: 16px;
				}
				.info{
					font-size: 14px;
					color: #333;
					margin-top: 12px;
					text-align: center;
				}
                .bianhao{
                    font-size: 14px;
					color: #999999;
					margin-top: 12px;
					text-align: center;
                }
    }
    .btnBox{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 50px;
        .cz{
            font-size: 14px;
            color: #999999;
            text-align: center;
            width: 170px;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            border: 1px solid #E5E5E5;
            margin: 0 10px;
            text-align: center;
            cursor: pointer;
        }
        .cxybz{
            width: 170px;
            height: 40px;
            background: #2196F3;
            line-height: 40px;
            border-radius: 4px;
            margin: 0 10px;
            color: #fff;
            text-align: center;
            cursor: pointer;
        }
	}
}
.successfulDalog{
    /deep/ .el-dialog{
        border-radius: 16px;
        overflow: hidden;
        position: absolute;
        margin: auto !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        padding: 0;
    }
}
</style>
